import { CANONICAL_SITE_URL } from '@/constants/metadata';

export const ORGANIZATION_JSON_LD = {
	'@context': 'https://schema.org',
	'@type': 'Organization',
	'@id': `${CANONICAL_SITE_URL}/#organization`,
	name: 'Qream',
	alternateName: 'Qream Agency',
	url: CANONICAL_SITE_URL,
	logo: {
		'@type': 'ImageObject',
		'@id': `${CANONICAL_SITE_URL}/#logo`,
		url: `${CANONICAL_SITE_URL}/assets/images/logo-square-green.svg`,
		width: 112,
		height: 112
	},
	email: 'collab@theqream.com',
	description:
		'Brand transformation boutique specializing in branding and web design for mid-size tech companies',
	knowsAbout: [
		'Brand Strategy',
		'Brand Identity Design',
		'Web Design',
		'UX Design',
		'Brand Transformation',
		'Design for Tech Companies'
	],
	sameAs: [
		'https://www.linkedin.com/company/qreamdesign',
		'https://www.behance.net/qream',
		'https://clutch.co/profile/qream'
	],
	address: {
		'@type': 'PostalAddress',
		addressLocality: 'Kyiv',
		addressCountry: 'UA'
	},
	foundingDate: '2018',
	numberOfEmployees: {
		'@type': 'QuantitativeValue',
		value: '30'
	}
} as const;
